var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: (_vm.width + "px"), height: (_vm.height + "px"), color: _vm.color})},[_c('icon',{staticClass:"w-full",class:_vm.currentType,attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }